import { Button, ErrorIllustration, ErrorState } from '@platform/ui';
import { type ErrorComponentProps, Link, useRouter } from '@tanstack/react-router';

import { errorMessage } from '../lib/api';

/**
 * Error boundary de las pantallas: un fallo de render o de carga no deja la consola en blanco. Se
 * puede reintentar (re-ejecuta los loaders) o volver al Overview.
 */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <div className="mx-auto flex max-w-xl flex-col gap-4 p-6">
      <ErrorIllustration className="h-28 self-center" />
      <ErrorState
        title="No se pudo mostrar esta pantalla"
        message={errorMessage(error)}
        onRetry={() => {
          reset();
          void router.invalidate();
        }}
      />
      <Button asChild variant="link" className="self-start">
        <Link to="/overview">Volver al inicio</Link>
      </Button>
    </div>
  );
}
